import logger from './logger'

/**
 * This is used in the bootstrapping process
 * to stop further work. Once the bootstrap reaches
 * a point where no more work can be done in the
 * sequence, we throw and instance of this class so
 * that the final catch statement on the bootstrap
 * promise chain can deal with the results.
 */

class RouteRedirect {
  constructor(errorText, route, model) {
    this.errorText = errorText
    this.route = route
    this.model = model

    logger(`WARNING :: (APP BOOTSTRAP) user being redirected to "${route}". Cause: "${errorText}"`, 'warning')()

    // TODO: analytics logging of users who
    // are redirected away from original final route

    return this
  }
}

export default RouteRedirect
